import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChess, faTriangleExclamation, faHandPointRight, faCircleExclamation, faLink } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';

export default function HelpModal(props) {
    const { t } = useTranslation();

    const renderOneRule = (icon, rule) => {
        return (
            <Row>
                <Col xs={1} md={1} lg={1}>
                    <FontAwesomeIcon icon={icon} style={{ paddingRight: 8 }} />
                </Col>
                <Col xs={11} md={11} lg={11}>
                    <p>{rule}</p>
                </Col>
            </Row>
        )
    }

    const renderCredits = () => {
        return (
            <Row style={{
                backgroundColor: "rgba(255,255,255,0.1)",
                padding: 12,
                paddingBottom: 0,
                paddingLeft: 0,
                marginBottom: 16,
                borderRadius: 8
            }}>

                        <Col xs={1} md={1} lg={1}>
                            <FontAwesomeIcon icon={faCircleExclamation} style={{ paddingRight: 8 }} />
                        </Col>
                        <Col xs={11} md={11} lg={11}>
                            <p> {t('credits_1')}<b>Thaeux</b>{t('credits_2')}<a id="credit-link" href="https://thaeux.itch.io/sumo-chess" target="_blank">thaeux.itch.io/sumo-chess</a></p>
                        </Col>
                    </Row>
        )
    }


    return (
        <Modal
            contentClassName="bg-dark text-white"
            show={props.show}
            onHide={props.onHide}>
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title style={{ letterSpacing: 2, fontWeight: 200 }}><FontAwesomeIcon icon={faChess} style={{ paddingRight: 8 }} />  {t('welcome')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_1')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_2')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_3')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_4')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_5')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_6')
                    )}
                    {renderOneRule(
                        faTriangleExclamation,
                        t('rule_7')
                    )}
                    {renderOneRule(
                        faHandPointRight,
                        t('rule_8')
                    )}
                    {
                        props.showCredits && renderCredits()
                    }
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>
                    {t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
